import markConversationsAsPhishingFromTable from './markConversationsAsPhishingFromTable';
import markItemsAsPhishingFromTable from './markItemsAsPhishingFromTable';
export default function markRowsAsPhishingFromTable(rowKeys, tableView, actionSource) {
    switch (tableView.tableQuery.listViewType) {
        case 0 /* Conversation */:
            markConversationsAsPhishingFromTable(rowKeys, tableView, actionSource);
            break;
        case 1 /* Message */:
            markItemsAsPhishingFromTable(rowKeys, tableView, actionSource);
            break;
    }
}
//# sourceMappingURL=markRowsAsPhishingFromTable.js.map